// @flow

import * as React from 'react';
import {Text} from 'sail/Text';
import Icon from 'sail/Icon';
import classnames from 'classnames';
import './Badge.scss';

type BadgeColor = 'gray' | 'blue' | 'cyan' | 'green' | 'yellow' | 'red';
const colors = ['gray', 'blue', 'cyan', 'green', 'yellow', 'red'];

type BadgeProps = {|
  color?: BadgeColor,
  label?: React.Node | string,
  id?: string,
  className?: string,
  icon?: string,
  iconPosition?: 'left' | 'right',
|};

export const Badge = ({
  color = 'gray',
  id,
  label,
  className,
  icon,
  iconPosition = 'right',
}: BadgeProps) => {
  // If the specified color is invalid, default to gray.
  const actualColor = colors.includes(color) ? color : 'gray';
  if (!icon) {
    return (
      <Text className={classnames('Badge', `Badge--${actualColor}`, className)}>
        {label}
      </Text>
    );
  }
  const inner = [
    <span key="label">{label}</span>,
    <Icon
      // $FlowExpectedError icon wants a specific string but we just have a generic one
      icon={icon}
      color={actualColor}
      size={10}
      className={`Badge-icon Badge-icon--${iconPosition}`}
      key="icon"
    />,
  ];
  if (iconPosition === 'left') {
    inner.reverse();
  }
  return (
    <Text className={classnames('Badge', `Badge--${actualColor}`, className)}>
      {inner}
    </Text>
  );
};
